import { render, staticRenderFns } from "./SkeletonBlock.vue?vue&type=template&id=0287372b&scoped=true"
import script from "./SkeletonBlock.vue?vue&type=script&lang=js"
export * from "./SkeletonBlock.vue?vue&type=script&lang=js"
import style0 from "./SkeletonBlock.vue?vue&type=style&index=0&id=0287372b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0287372b",
  null
  
)

export default component.exports